// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NkK9","questions":"styles_questions__3o8Zz","footer":"styles_footer__iMwFr"};